import { Colors } from '@sigma-frontend-libs/commons'

import { icons, services } from '@/utils'

import sticker from '@/components/sticker'
import date from '@/components/templates/service/item/date'

function renderTitle(h) {
  let icon = icons.error_outline
  let color = Colors.error
  let activeKey = 'notActive'
  if (this.value.isActive) {
    icon = icons.check_circle_outline
    color = Colors.success
    activeKey = 'active'
  }

  return h(
    sticker,
    {
      props: {
        value: this.value,
        label: `${this.getTranslate(`${services.keywordLists}.labels.title`)}`,
        icon,
        color,
        iconTooltip: this.getTranslate(`${services.keywordLists}.tooltips.${activeKey}`),
        service: services.keywordLists,
        width: 'fit-content'
      }
    }
  )
}

function renderCreatedAt(h) {
  return h(
    date,
    {
      props: {
        value: this.value
      }
    }
  )
}

export default function(h) {
  return h(
    'div',
    {
      class: {
        'service-template-item': true,
        [`${services.keywordLists}-panel`]: true
      }
    },
    [
      renderTitle.call(this, h),
      renderCreatedAt.call(this, h)
    ]
  )
}
